export default __webpack_public_path__ + "static/media/logo_thaiwah_ventures.c572fff6.png";